import styles from "./Input.module.scss";
import MaskedInput from 'react-text-mask'
export default function MobileInput({ label, id, error, mandatory, ...props }) {
  return (
    <>
      <div className={styles.formGroup}>
        <label htmlFor={id}>{label}
        {mandatory&& <label className={styles.mandatory}>*</label>}
        <MaskedInput {...props}
      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}></MaskedInput>
       </label>
        <div className="error">{error && <p>{error}</p>}</div>
      </div>
    </>
  );
}
